import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { homeFor } from "@/pages/public/Login";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        nav(homeFor(data), { replace: true, state: { user: data } });
      })
      .catch((e) => {
        setUser(false);
        toast.error(formatApiError(e));
        nav("/connexion", { replace: true });
      });
  }, [location, nav, setUser]);

  return null;
}
